import UnratedRatingDetail from './UnratedRatingDetail.jsx';
import './UnratedRatingDetail.css';

export default UnratedRatingDetail;
